import {Button, Text, Textarea, VStack} from "@chakra-ui/react";
import * as React from "react";
import {ChangeEvent, useEffect, useRef} from "react";
import {changePage, setFieldModel, setIsLeftToRight} from "../../../store/reducers";
import {useAppDispatch, useAppSelector} from "../../../hooks/use-store";
import {useForm} from "react-hook-form";
import {ProducerModelQueryParamsNew} from "../../../data/model/Producer";
import {yupResolver} from "@hookform/resolvers/yup";
import {signupProducerSchemaThreeNew} from "../../../data/schema/signup";
import {ImageSelectorComponent} from "../../../components/molecules/ImageSelectorComponent/ImageSelectorComponent";
import {MediaSelectorComponent} from "../../../components/molecules/MediaSelectorComponent/MediaSelectorComponent";

export const toBase64 = (file: File | null) => new Promise((resolve, reject) => {
    if (!file) return undefined;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

export const SignupPageThree = () => {
    const {currentPage, producer} = useAppSelector((state) => state.landing);
    const dispatch = useAppDispatch();

    const {imagesUpload, logoUpload} = producer || {};

    const logoInputRef: React.RefObject<HTMLInputElement> = useRef(null);

    const imageInputRef: React.RefObject<HTMLInputElement> = useRef(null);

    const {description} = producer || {};

    const methods = useForm<ProducerModelQueryParamsNew>({
        mode: "all",
        resolver: yupResolver(signupProducerSchemaThreeNew)
    });

    const {
        register,
        setValue,
        getValues,
        trigger
    } = methods;

    useEffect(() => {
        if (description) {
            setValue("description", description);
            trigger("description").then(_ => {
            });
        }
    }, [description]);

    const handleLogoChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            dispatch(setFieldModel({
                logoUpload: {
                    file,
                    imageUrl: URL.createObjectURL(file),
                    isMain: true
                }
            }))
        }
    };

    const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];

            dispatch(setFieldModel({
                imagesUpload: [...(imagesUpload || []), {
                    file,
                    imageUrl: URL.createObjectURL(file),
                    isMain: false
                }]
            }))
        }
    };

    function onSubmit() {
        const values = getValues();
        dispatch(setFieldModel(values));
        dispatch(setIsLeftToRight(false));
        dispatch(changePage((currentPage ?? 0) + 1));
    }

    const handleLogoButtonClick = () => {
        logoInputRef?.current?.click();
    }

    const handleImageButtonClick = () => {
        imageInputRef?.current?.click();
    }

    return <VStack>
        <Text
            color={"primary.400"}
            alignSelf={"start"}
            fontSize={16}>Descrizione</Text>

        <Textarea
            id={"description"}
            focusBorderColor={"primary.400"}
            colorScheme={"primary"}
            variant='filled'
            noOfLines={8}
            _placeholder={{
                fontSize: 14
            }}
            {...register('description')}
            placeholder='Inserisci una presentazione o descrizione della tua azienda.'/>

            <Text
                textAlign={"center"}
                color={"primary.400"}
                alignSelf={"flex-start"}
                mt={"16px"}
                fontSize={16}>Logo</Text>

        <ImageSelectorComponent mt={"16px"} setImageModelFunction={(model) => {
            model && dispatch(setFieldModel({
                logoUpload: model
            }));
        }} handleCloseButtonClick={() => {
            dispatch(setFieldModel({logoUpload: undefined}));
        }} imageModel={logoUpload} isMain={true}/>

        {/*<VStack w={"100%"}>*/}
        {/*    <Text*/}
        {/*        textAlign={"center"}*/}
        {/*        color={"primary.400"}*/}
        {/*        alignSelf={"flex-start"}*/}
        {/*        mt={"16px"}*/}
        {/*        fontSize={16}>Logo</Text>*/}

        {/*    <Input*/}
        {/*        type="file"*/}
        {/*        id="image"*/}
        {/*        accept="image/*"*/}
        {/*        ref={logoInputRef}*/}
        {/*        onChange={handleLogoChange}*/}
        {/*        style={{display: 'none'}}*/}
        {/*    />*/}

        {/*    {!logoUpload && <Button*/}
        {/*        colorScheme="teal"*/}
        {/*        mt={"8px"}*/}
        {/*        w={"100%"}*/}
        {/*        h={"64px"}*/}
        {/*        leftIcon={<ImageIcon w={"32px"} h={"32px"}/>}*/}
        {/*        onClick={handleLogoButtonClick}>Scegli un logo</Button>}*/}
        {/*</VStack>*/}

        {/*{logoUpload?.imageUrl && <Box position={"relative"}>*/}
        {/*    <CloseIcon cursor={"pointer"} right={0} position={"absolute"} borderRadius={"50%"} color={"white"} p={"8px"}*/}
        {/*               w={"32px"}*/}
        {/*               h={"32px"}*/}
        {/*               backgroundColor={"error.700"} onClick={() => {*/}
        {/*        // setSelectedIconFile(null);*/}
        {/*        // setImageIconUrl(null);*/}
        {/*        dispatch(setFieldModel({logoUpload: undefined}));*/}
        {/*    }}/>*/}
        {/*    <Image src={logoUpload.imageUrl} alt="Uploaded Image" maxW="200px"/>*/}
        {/*</Box>}*/}

        <Text
            textAlign={"center"}
            color={"primary.400"}
            alignSelf={"flex-start"}
            mt={"16px"}
            fontSize={16}>Immagini</Text>

        <MediaSelectorComponent
            setImageModelFunction={(model) => dispatch(setFieldModel({
                imagesUpload: [...(model || [])]
            }))}
            images={imagesUpload || []}
            description={"Seleziona le foto, i video o gli audio che vorresti utilizzare per descrivere al meglio il tuo prodotto."}
        />
        {/*{imagesUpload?.map((value, index) => {
            return <VStack key={`image_section_${index}`}>
                {value?.imageUrl && <Box position={"relative"}>
                    <CloseIcon cursor={"pointer"} right={0} position={"absolute"} borderRadius={"50%"} color={"white"}
                               p={"8px"}
                               w={"32px"}
                               h={"32px"}
                               backgroundColor={"error.700"} onClick={() => {
                        dispatch(setFieldModel({imagesUpload: removeItemAtIndex(imagesUpload, index)}));
                    }}/>
                    <Image src={value.imageUrl} alt="Uploaded Image" maxW="200px"/>
                </Box>}
            </VStack>
        })}

        <Input
            type="file"
            id="image"
            accept="image/*"
            ref={imageInputRef}
            onChange={handleImageChange}
            style={{display: 'none'}}
        />

        <Button
            colorScheme="teal"
            mt={"8px"}
            w={"100%"}
            h={"64px"}
            leftIcon={<ImageIcon w={"32px"} h={"32px"}/>}
            onClick={handleImageButtonClick}>Scegli un'immagine</Button>*/}

        {currentPage !== 3 && <Button
            variant={"primary"}
            mt={"36px"}
            onClick={() => {
                onSubmit();
            }}
        >Avanti</Button>}

        {currentPage !== 0 && <Button
            variant={"tertiary"}
            {...currentPage !== 0 && {
                mb: "24px"
            }}
            mt={"8px"}
            onClick={() => {
                dispatch(setIsLeftToRight(true));
                dispatch(changePage((currentPage ?? 0) - 1));
            }}
        >Indietro</Button>}
    </VStack>
}
